import { getSVFs } from '../../axios/Reintegro';
import { GET_INDICACIONES } from '../../axios/Utils/constants';
import { SVF } from '../../types/Siniestro/types';
import { useFetchEntity } from '../Utils/useEntity';

export const useGetSVFs = (siniestroId?: string) => {
  const id = siniestroId;
  const key = id ? `${GET_INDICACIONES}-${id}` : null;

  const { data, error, isValidating, mutate } = useFetchEntity<SVF[]>(key, async () => {
    const res = await getSVFs(id);
    return res.data;
  });

  return {
    SVFs: data,
    error,
    isValidating,
    mutate,
  };
};
